import { defineMessages } from "react-intl";
const messages = defineMessages({
    studioTitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.studio.title",
        defaultMessage: "Studio",
    },
    studioSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.studio.subtitle",
        defaultMessage: "Example: [studios] under [$2,500]",
    },
    studioTooltip: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.studio.tooltip",
        defaultMessage: "Studio apartment pricing subtopics",
    },
    oneBedroomTitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.oneBedroom.title",
        defaultMessage: "1 Bedroom",
    },
    oneBedroomSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.oneBedroom.subtitle",
        defaultMessage: "Example: [1 Bedrooms] under [$2,500]",
    },
    oneBedroomTooltip: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.oneBedroom.tooltip",
        defaultMessage: "1 bedroom apartment pricing subtopics",
    },
    twoBedroomsTitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.twoBedrooms.title",
        defaultMessage: "2 Bedrooms",
    },
    twoBedroomsSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.twoBedrooms.subtitle",
        defaultMessage: "Example: [2 Bedrooms] under [$2,500]",
    },
    twoBedroomsTooltip: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.twoBedrooms.tooltip",
        defaultMessage: "2 bedrooms apartment pricing subtopics",
    },
    threeBedroomsTitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.threeBedrooms.title",
        defaultMessage: "3+ Bedroom",
    },
    threeBedroomsSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.threeBedrooms.subtitle",
        defaultMessage: "Example: [3 Bedrooms] under [$2,500]",
    },
    threeBedroomsTooltip: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.threeBedrooms.tooltip",
        defaultMessage: "3+ bedrooms apartment pricing subtopics",
    },
    hideSubtopicTooltip: {
        id: "app.aiDiscoverability.customSubtopics.priceLayoutTab.hideSubtopic",
        defaultMessage: "Hide subtopic",
    },
});
export default messages;
